import { render, staticRenderFns } from "./UpcomingAndCurrentExams.vue?vue&type=template&id=2ca5448d&scoped=true&"
import script from "./UpcomingAndCurrentExams.vue?vue&type=script&lang=js&"
export * from "./UpcomingAndCurrentExams.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingAndCurrentExams.vue?vue&type=style&index=0&id=2ca5448d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca5448d",
  null
  
)

export default component.exports